export default __webpack_public_path__ + "c231011fbd1b0d824408ddf8cfc7940c.png";